/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_minute').html(cutDownTimeText.minute)
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
      $('.sp_second').html(cutDownTimeText.second)
    }, 1000)
  }

  getCutDownTime()

  new WOW().init()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20260119-p1.png',
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20260119-p2.png',
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20260119-p3.png',

    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/lQLPM43ENVCykynNAinNAsKwmpSMfHa9h-QJkY950EVFAA_706_553.png?v=1773832687',
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/lQLPM5iaKsdDMynM-c0Cy7D4QVfL0Q3H2gmRj3oePtsA_715_249.png?v=1773832687',
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/lQLPD4dPGLkEEKnNAQDNAq6woKOrXHSbdrMJkY96S3wDAA_686_256.png?v=1773832687',

    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/2026_2_25__1.png?v=1772013761',
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/2026_2_25__2.png?v=1772013761',
    'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/2026_2_25__3.png?v=1772013761',
  ]
  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }


  preloadImages(spImgList);
  new Swiper('.mySwiper1', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 49,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.mySwiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
  new Swiper('.sp-swiper1', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 49,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  new Swiper('.sp-swiper2', {
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 42,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })

  new Swiper('.sp-swiper-fade', {
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })
  new Swiper('.sp-swiper-fade1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  })
  new Swiper('.sp-swiper-fade2', {
    slidesPerView: 2,
    spaceBetween: 0,
    centeredSlides: true,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
    },
  })
  var _index = 0
  $('.opt-group .option').click(function () {
    $(this).addClass('active').siblings().removeClass('active')
    changePrice()
  })
  $('#color .option').click(function () {
    var index = $(this).index()
    var index2 = $('#size .option.active').index()
    changeOptions(index, index2)
  })
  $('#size .option').click(function () {
    var index = $('#color .option.active').index()
    var index2 = $(this).index()
    changeOptions(index, index2)
  })
  function changeOptions(index, index2) {
    // 两个选项的下标相加得到图片索引
    var imgIndex = index + index2 * 3
    _index = index
    
    // 更新图片显示
    $('.sp-pro-imgs .sp-image img').attr('src', spImgList[imgIndex])
    // $('.sp-pro-imgs .sp-image img').attr('src', 'https://cdn.shopify.com/s/files/1/0586/6556/6293/files/20260119-p' + (index + 1) + '.png')
    
    // 根据第二个选项(size)的索引来控制显示
    if (index2 == 0) {
      $('.sp-pro-icon').show()
    } else if (index2 == 1) {
      var text = 2
      if (index == 0) {
        text = 2
      } else if (index == 1) {
        text = 5
      } else if (index == 2) {
        text = 10
      }
      $('.sp-green-icons').text('x' + text)
      $('.sp-pro-icon').hide()
    }
  }
  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1060) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1060) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    // preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        let sptop =
          document.body.clientWidth <= 1080
            ? $('.sp-mobile .header-wrap').height()
            : $('.sp-pc .header-wrap').height()
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  let sp_price1 = 9.99
  let sp_price2 = 19.89

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)
    return result.toFixed(2)
  }
  let prods = window.product
    function getCur(){
        let opt1 = $('#color div.active').attr('data-val')
        let opt2 = $('#size div.active').attr('data-val')
        return prods.filter(item=> item.option1 == opt1 && item.option2 == opt2)[0]
    }
    function changePrice(){
        let num = $('#calcNumber').val()
        let price = (getCur().price * num / 100).toFixed(2)
        let compare = (getCur().compare_at_price * num / 100).toFixed(2)
        price = (price + '').replace('.', ',')
        compare = (compare + '').replace('.', ',')
        console.log(price)
        $('#sp_price1').html(price)
        $('#sp_price2').html(compare)
        let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
        $(".product-part .price-group .off-font").html(off_font);
    
    }
    
    $('.sp-btn-style').click(function(){
        let num = $('#calcNumber').val()
        window.location.href = '/cart/' + getCur().id + ':' + num
    })
  $('.sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    changePrice()
  })
  $('.sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num
    changePrice()
  })

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });
  // 加入购物车
  addCart()
  function addCart() {
    // 加入购物车
    $('.addCerts').click(function () {
      //
      // do something here

      var data = {
        id: getCur().id,
        quantity: $('#calcNumber').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            // $("#cardNum").html(result.item_count);
            $(".sp-cart .num").each(function () {
                $(this).html(result.item_count);
                $(this).css('background', '#cf0101');

            });
          });
        },
        dataType: "json",
      });
      var img = $('.sp-pro-imgs .sp-image')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.product-part').append(flyer)
      $('.clone').css({
        width: img.width(),
        height: img.height(),
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-cart')[0].getBoundingClientRect()
      $('.sp-cart').addClass('shake')
      setTimeout(() => {
        $('.sp-cart').removeClass('shake')
      }, 1000)
      var finish
      var widths
      if (document.body.clientWidth >= 1080) {
        finish = $('.sp-cart-pc')
        widths = $('.sp-cart-pc').width()
      } else {
        finish = $('.sp-btn-style2 .sp-cart')
        widths = $('.sp-btn-style2 .sp-cart').width()
      }
      console.log(finish[0])
      $('.clone').animate(
        {
          top: document.body.clientWidth >= 1080 ? finish[0].offsetTop : '100%',
          left:
            document.body.clientWidth >= 1080
              ? $('.sp-pc .sp-cart-pc')[0].offsetLeft + widths * 2 
              : $('.sp-btn-style2 .sp-info')[0].offsetLeft + widths * 2 ,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }
  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 初始隐藏按钮
  $('.sp-btn-style2').css('opacity', '0')
  $('.sp-btn-style2').css('pointer-events', 'none')

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp-header').height() * $('div#root').css('zoom')
  ) {
    $('.header-wrap').addClass('sp-fixed')
  } else {
    $('.header-wrap').removeClass('sp-fixed')
  }

  // 滚动显示底部按钮
  function toggleBottomButton() {
    const scrollTop = $(window).scrollTop()
    const windowHeight = $(window).height()
    const showScrollDistance = windowHeight * 0.5 // 滚动超过首屏高度的50%后显示

    if (scrollTop > showScrollDistance) {
      $('.sp-btn-style2').css('opacity', '1')
      $('.sp-btn-style2').css('pointer-events', 'auto')
      $('.sp-btn-style2').css('transition', 'opacity 0.3s ease')
    } else {
      $('.sp-btn-style2').css('opacity', '0')
      $('.sp-btn-style2').css('pointer-events', 'none')
    }
  }

  // 初始检查
  toggleBottomButton()

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp-header').height() * $('div#root').css('zoom')
    ) {
      $('.header-wrap').addClass('sp-fixed')
    } else {
      $('.header-wrap').removeClass('sp-fixed')
    }

    // 控制底部按钮显示/隐藏
    toggleBottomButton()
  })

  // 问答
  $('.q-row').click(function () {
    $(this).parent().toggleClass('sp-show')
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }

  // 视频进入视口时自动播放
  const videos = document.querySelectorAll('.sp-video')
  const videoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 视频进入视口时播放
          entry.target.play().catch((error) => {
            // 如果自动播放失败（比如用户设置了阻止自动播放），静默处理
            console.log('视频自动播放失败:', error)
          })
        } else {
          // 视频离开视口时暂停
          entry.target.pause()
        }
      })
    },
    {
      threshold: 0.3, // 当视频30%可见时触发
    }
  )

  videos.forEach((video) => {
    videoObserver.observe(video)
  })
})
